import * as React from 'react';
import DiagramModel from 'src/model/diagram.model';

import './Diagram.scss';

interface IDiagramProps {
  diagram: DiagramModel;
  active: boolean;
  onClickAction(diagramId: number, active: boolean): any;
}

const Diagram: React.SFC<IDiagramProps> = props => {
  const { diagram } = props;
  const activeClass = props.active ? 'active' : '';
  return (
    <div
      className="rp-diagrams-display--diagram"
      onClick={() => {
        props.onClickAction(diagram.diagramId, props.active);
      }}
    >
      <img
        className={`diagramImage ${activeClass}`}
        src={diagram.urlDiagram}
        alt=""
      />
      <p className={`diagramName ${activeClass}`}>
        {diagram.diagramName ? diagram.diagramName : diagram.diagramId}
      </p>
    </div>
  );
};

export default Diagram;
